import Button from "components/common/buttons/buttons";
import CommentInput from "./Input";
import { useCallback, useRef, useState } from "react";
import { useDebateContext } from "contexts/DebateContext";

function OpinionInput({ isMobile }: { isMobile: boolean }) {
  const [bottomButtonDisplay, setBottomButtonDisplay] = useState(false);
  const optionInputObserverRef = useRef<IntersectionObserver | null>(null);
  const optionInputElementRef = useRef<HTMLDivElement | null>(null);

  const optionInputObserve = useCallback((node: HTMLDivElement | null) => {
    if (optionInputObserverRef?.current)
      optionInputObserverRef.current.disconnect();

    // node 가 화면에서 사라지면 setBottomButtonDisplay(true)
    if (node) {
      optionInputElementRef.current = node;
      optionInputObserverRef.current = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) {
          setBottomButtonDisplay(true);
        } else {
          setBottomButtonDisplay(false);
        }
      });
      optionInputObserverRef.current.observe(node);
    }
  }, []);

  return (
    <div>
      <div className="px-6 py-2 " ref={optionInputObserve} id="opinion-input">
        <CommentInput type="opinion" mode="input" />
      </div>
      {/* <div
        className={
          isMobile
            ? ` z-[99] bg-white w-full px-5 pt-4 pb-[30px] fixed bottom-0 left-0 !font-semibold flex flex-col gap-4 ${
                bottomButtonDisplay ? "block" : "hidden"
              } `
            : `z-[99] bg-white w-[800px] px-5 pt-4 pb-[30px] fixed bottom-0 left-[50%] translate-x-[-50%] !font-semibold flex flex-col gap-4 ${
                bottomButtonDisplay ? "block" : "hidden"
              } `
        }
      >
        <Button
          type="primary"
          size="lg"
          text="내 의견 남기기"
          width="w-full"
          clickHandler={() => {
            //optionInputElementRef의 스크롤 위치로 이동
            if (optionInputElementRef?.current) {
              const element = optionInputElementRef.current;
              if (element instanceof Element) {
                setTimeout(() => {
                  try {
                    element.scrollIntoView({
                      behavior: "smooth",
                      block: "center", // "start" 대신 "center" 사용
                      inline: "nearest",
                    });
                  } catch (error) {
                    const elementRect = element.getBoundingClientRect();
                    const absoluteElementTop =
                      elementRect.top + window.pageYOffset;
                    const middle = absoluteElementTop - window.innerHeight / 2;
                    window.scrollTo({
                      top: middle,
                      behavior: "smooth",
                    });
                  }
                }, 100);
              }
            }
          }}
        />
      </div> */}
    </div>
  );
}

export default OpinionInput;
